/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EffectiveLiveState } from './EffectiveLiveState';
import {
    EffectiveLiveStateFromJSON,
    EffectiveLiveStateFromJSONTyped,
    EffectiveLiveStateToJSON,
    EffectiveLiveStateToJSONTyped,
} from './EffectiveLiveState';

/**
 * The row player's live stream, resolved from their Drop. Present only when the Drop has streaming enabled and the broadcast matches this board's game. Field names mirror the web InlinePlayerSource so a client maps with a spread. effectiveLiveState UNKNOWN means the detector went quiet, not that the creator went dark — render no badge, exclude from live counts, do not offer as a POV.
 * @export
 * @interface LeaderboardStandingStream
 */
export interface LeaderboardStandingStream {
    /**
     * Deliberately NOT a $ref to the shared StreamingPlatform, which also carries MULTI. MULTI is a Drop-level aggregate, never a single embeddable source, so referencing it would hand clients a case the server cannot emit. Same triple the Drop-In directory's player-source schemas declare.
     * @type {string}
     * @memberof LeaderboardStandingStream
     */
    platform: LeaderboardStandingStreamPlatformEnum;
    /**
     * 
     * @type {string}
     * @memberof LeaderboardStandingStream
     */
    twitchChannelId?: string;
    /**
     * 
     * @type {string}
     * @memberof LeaderboardStandingStream
     */
    kickChannelSlug?: string;
    /**
     * Channel id. Kept separate from youtubeLiveId — a channel and a video produce different embed URLs and different chat URLs.
     * @type {string}
     * @memberof LeaderboardStandingStream
     */
    youtubeChannelId?: string;
    /**
     * Live video id. Kept separate from youtubeChannelId.
     * @type {string}
     * @memberof LeaderboardStandingStream
     */
    youtubeLiveId?: string;
    /**
     * 
     * @type {EffectiveLiveState}
     * @memberof LeaderboardStandingStream
     */
    effectiveLiveState: EffectiveLiveState;
    /**
     * 
     * @type {number}
     * @memberof LeaderboardStandingStream
     */
    viewerCount?: number;
    /**
     * 
     * @type {string}
     * @memberof LeaderboardStandingStream
     */
    streamTitle?: string;
    /**
     * 
     * @type {string}
     * @memberof LeaderboardStandingStream
     */
    profileImageUrl?: string;
    /**
     * Deep-link target — /drop-in/{slug}.
     * @type {string}
     * @memberof LeaderboardStandingStream
     */
    dropSlug: string;
}


/**
 * @export
 */
export const LeaderboardStandingStreamPlatformEnum = {
    TWITCH: 'TWITCH',
    KICK: 'KICK',
    YOUTUBE: 'YOUTUBE'
} as const;
export type LeaderboardStandingStreamPlatformEnum = typeof LeaderboardStandingStreamPlatformEnum[keyof typeof LeaderboardStandingStreamPlatformEnum];


/**
 * Check if a given object implements the LeaderboardStandingStream interface.
 */
export function instanceOfLeaderboardStandingStream(value: object): value is LeaderboardStandingStream {
    if (!('platform' in value) || value['platform'] === undefined) return false;
    if (!('effectiveLiveState' in value) || value['effectiveLiveState'] === undefined) return false;
    if (!('dropSlug' in value) || value['dropSlug'] === undefined) return false;
    return true;
}

export function LeaderboardStandingStreamFromJSON(json: any): LeaderboardStandingStream {
    return LeaderboardStandingStreamFromJSONTyped(json, false);
}

export function LeaderboardStandingStreamFromJSONTyped(json: any, ignoreDiscriminator: boolean): LeaderboardStandingStream {
    if (json == null) {
        return json;
    }
    return {
        
        'platform': json['platform'],
        'twitchChannelId': json['twitchChannelId'] == null ? undefined : json['twitchChannelId'],
        'kickChannelSlug': json['kickChannelSlug'] == null ? undefined : json['kickChannelSlug'],
        'youtubeChannelId': json['youtubeChannelId'] == null ? undefined : json['youtubeChannelId'],
        'youtubeLiveId': json['youtubeLiveId'] == null ? undefined : json['youtubeLiveId'],
        'effectiveLiveState': EffectiveLiveStateFromJSON(json['effectiveLiveState']),
        'viewerCount': json['viewerCount'] == null ? undefined : json['viewerCount'],
        'streamTitle': json['streamTitle'] == null ? undefined : json['streamTitle'],
        'profileImageUrl': json['profileImageUrl'] == null ? undefined : json['profileImageUrl'],
        'dropSlug': json['dropSlug'],
    };
}

export function LeaderboardStandingStreamToJSON(json: any): LeaderboardStandingStream {
    return LeaderboardStandingStreamToJSONTyped(json, false);
}

export function LeaderboardStandingStreamToJSONTyped(value?: LeaderboardStandingStream | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'platform': value['platform'],
        'twitchChannelId': value['twitchChannelId'],
        'kickChannelSlug': value['kickChannelSlug'],
        'youtubeChannelId': value['youtubeChannelId'],
        'youtubeLiveId': value['youtubeLiveId'],
        'effectiveLiveState': EffectiveLiveStateToJSON(value['effectiveLiveState']),
        'viewerCount': value['viewerCount'],
        'streamTitle': value['streamTitle'],
        'profileImageUrl': value['profileImageUrl'],
        'dropSlug': value['dropSlug'],
    };
}

